module.exports = __webpack_public_path__ + "img/11.5e739b2c.png";